import { useAtom } from 'jotai'
import { atomWithStorage } from 'jotai/utils'

const DEV_TOOLS_KEY = 'enable-sequence-dev-tools'

/**
 * Whether the Sequence dev tools - the bar down the left hand side - are
 * showing. On by default when you're running from source, off in every
 * deployed environment, and a stored choice beats both.
 *
 * `getOnInit` matters: without it the atom reports the default until something
 * mounts it, so a stored-on bar would flash into view a moment after load. It
 * also means storage is read once, as the module loads - setting the key by
 * hand still works, but only from the next page load.
 */
export const devToolsEnabledAtom = atomWithStorage<boolean>(
  DEV_TOOLS_KEY,
  import.meta.env.DEV,
  undefined,
  { getOnInit: true }
)

/**
 * Flipping this shows or hides the tools straight away, no reload needed, and
 * the choice sticks around for the next visit.
 */
export const useDevToolsEnabled = () => useAtom(devToolsEnabledAtom)
